import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_10 = { class: "custom-title flex flex-col" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "flex items-center space-x-1" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { style: {"overflow-y":"auto","height":"calc(100vh - 177px)"} }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-center items-center h-full text-gray-500"
}
const _hoisted_16 = { class: "flex flex-col justify-between" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { class: "flex justify-end text-2xl" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_23 = { class: "hidden md:block w-full" }
const _hoisted_24 = {
  key: 0,
  class: "w-16 flex items-center"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "flex flex-col md:flex-row" }
const _hoisted_29 = { class: "flex-1" }
const _hoisted_30 = { class: "flex-1" }
const _hoisted_31 = { class: "flex flex-col md:flex-row" }
const _hoisted_32 = { class: "flex-1" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 0,
  class: "dialog-footer"
}
const _hoisted_37 = {
  key: 1,
  class: "dialog-footer"
}
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = { class: "text-lg font-medium text-gray-900" }
const _hoisted_40 = { class: "flex justify-center items-center w-full h-full" }
const _hoisted_41 = {
  key: 0,
  class: "flex justify-end mt-4"
}
const _hoisted_42 = { class: "dialog-footer flex flex-col" }
const _hoisted_43 = { class: "flex justify-end mb-2 min-h-6" }
const _hoisted_44 = {
  key: 0,
  class: "text-red-500 text-sm"
}
const _hoisted_45 = { class: "flex items-center" }
const _hoisted_46 = { class: "flex gap-2 ml-auto" }
const _hoisted_47 = { class: "dialog-footer" }
const _hoisted_48 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top",
                  rules: _ctx.searchRules,
                  ref: "searchFormRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-6' : 'md:grid-cols-5',
                            ]])
                    }, [
                      (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: "no-margin",
                            label: "組織",
                            prop: "organization_id"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "払出元部門",
                        prop: "target_department_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            modelValue: _ctx.searchForm.target_department_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.target_department_id) = $event)),
                            "is-exclude-target-department": true,
                            "target-department-id": _ctx.searchForm.dest_department_id,
                            onDepartmentNameChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTargetDepartmentNameChange($event))),
                            onOrganizationIdChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchForm.organization_id = $event)),
                            placeholder: "払出元部門を選択"
                          }, null, 8, ["organization-id", "modelValue", "target-department-id"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "払出先部門",
                        prop: "dest_department_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            modelValue: _ctx.searchForm.dest_department_id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.dest_department_id) = $event)),
                            "is-exclude-target-department": true,
                            "target-department-id": _ctx.searchForm.target_department_id,
                            onDepartmentNameChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleDestDepartmentNameChange($event))),
                            onOrganizationIdChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchForm.organization_id = $event)),
                            placeholder: "払出先部門を選択"
                          }, null, 8, ["organization-id", "modelValue", "target-department-id"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "カテゴリ"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CategorySelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            modelValue: _ctx.searchForm.category_id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                            "is-search": true,
                            placeholder: "カテゴリを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "アイテム名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AutoCompleteInput, {
                            modelValue: _ctx.searchForm.material_name,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                            placeholder: "アイテム名を入力",
                            "storage-key": "material-name-history",
                            "max-history-items": 15,
                            ref: "materialNameInput"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSearchButton(_ctx.searchFormRef)))
                        }, {
                          default: _withCtx(() => _cache[50] || (_cache[50] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        })
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top",
                      rules: _ctx.searchRules,
                      ref: "searchFormRef"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                class: "no-margin",
                                label: "組織",
                                prop: "organization_id"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_OrganizationSelect, {
                                    modelValue: _ctx.searchForm.organization_id,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                    placeholder: "組織を選択"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "払出元部門",
                            prop: "target_department_id"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                modelValue: _ctx.searchForm.target_department_id,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchForm.target_department_id) = $event)),
                                "is-exclude-target-department": true,
                                "target-department-id": _ctx.searchForm.dest_department_id,
                                onDepartmentNameChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleTargetDepartmentNameChange($event))),
                                onOrganizationIdChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.searchForm.organization_id = $event)),
                                placeholder: "払出元部門を選択"
                              }, null, 8, ["organization-id", "modelValue", "target-department-id"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "払出先部門",
                            prop: "dest_department_id"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                modelValue: _ctx.searchForm.dest_department_id,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchForm.dest_department_id) = $event)),
                                "is-exclude-target-department": true,
                                "target-department-id": _ctx.searchForm.target_department_id,
                                onDepartmentNameChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleDestDepartmentNameChange($event))),
                                onOrganizationIdChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.searchForm.organization_id = $event)),
                                placeholder: "払出先部門を選択"
                              }, null, 8, ["organization-id", "modelValue", "target-department-id"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "カテゴリ"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CategorySelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                modelValue: _ctx.searchForm.category_id,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                                "is-search": true,
                                placeholder: "カテゴリを選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "アイテム名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteInput, {
                                  modelValue: _ctx.searchForm.material_name,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                                  placeholder: "アイテム名を入力",
                                  "storage-key": "material-name-history",
                                  "max-history-items": 15,
                                  ref: "materialNameInput"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSearchButton(_ctx.searchFormRef))),
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _ctx.handleProcessButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " trolley ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-24",
                  type: "info",
                  onClick: _ctx.handleProcessButton
                }, {
                  default: _withCtx(() => _cache[54] || (_cache[54] = [
                    _createTextVNode("処理")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, { style: {"padding":"0px","padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[59] || (_cache[59] = _createElementVNode("span", null, "払い出し（アイテム名　在庫数）", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleSort('material_name'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'material_name' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[55] || (_cache[55] = [
                        _createTextVNode(" アイテム名 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSort('storage_date'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'storage_date' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[56] || (_cache[56] = [
                        _createTextVNode(" 保管日 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleSort('expiration_date'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'expiration_date' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                        _createTextVNode(" 有効期限 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", _hoisted_13, "アイテム数: " + _toDisplayString(_ctx.totalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.tableData.length === 0 && (!_ctx.searchForm.organization_id || !_ctx.searchForm.target_department_id || !_ctx.searchForm.dest_department_id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 組織、払出元部門、払出先部門を選択してください "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    key: item.inventory_id,
                    style: {"border":"1px solid #d1d5db","border-radius":"0px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.category_name), 1)
                      ]),
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 19 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", null, "保管日: " + _toDisplayString(_ctx.formatDate(item.storage_date!)), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass({ 'text-red-500': _ctx.isExpired(item.expiration_date) })
                                }, " 有効期限: " + _toDisplayString(_ctx.formatDate(item.expiration_date)), 3)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(item.quantity), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (item.quantity > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _cache[63] || (_cache[63] = _createElementVNode("span", null, "払い出し方法: ", -1)),
                            (item.payMode === 0)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "info"
                                }, {
                                  default: _withCtx(() => _cache[60] || (_cache[60] = [
                                    _createTextVNode("新規")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.payMode === 1)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => _cache[61] || (_cache[61] = [
                                    _createTextVNode("選択")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.payMode === 2)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 2,
                                  type: "success"
                                }, {
                                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                                    _createTextVNode("追加")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.payMode === 1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: "material-symbols-outlined cursor-pointer",
                                  onClick: ($event: any) => (_ctx.handlePayModeButton(item))
                                }, " stat_minus_1 ", 8, _hoisted_21))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (item.quantity > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _cache[64] || (_cache[64] = _createElementVNode("span", null, "払出数量: ", -1)),
                            _createVNode(_component_el_form_item, { class: "no-margin" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: item.payQuantity,
                                  "onUpdate:modelValue": ($event: any) => ((item.payQuantity) = $event),
                                  min: 0,
                                  max: item.quantity,
                                  "value-on-clear": 0,
                                  onFocus: ($event: any) => (_ctx.handlePayQuantityChange(item)),
                                  onChange: ($event: any) => (_ctx.handlePayQuantityChange(item))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onFocus", "onChange"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.tableData,
                height: "calc(100vh - 290px)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "organization_name",
                    label: "組織",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "department_name",
                    label: "部署",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "category_name",
                    label: "カテゴリ",
                    width: "100"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleSort('category_name')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                            }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "material_name",
                    label: "アイテム名"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSort('material_name')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('material_name')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'material_name' }])
                            }, _toDisplayString(_ctx.getSortIcon('material_name')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "storage_date",
                    label: "保管日",
                    width: "200"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleSort('storage_date')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('storage_date')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'storage_date' }])
                            }, _toDisplayString(_ctx.getSortIcon('storage_date')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.storage_date)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "expiration_date",
                    label: "有効期限",
                    width: "200"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleSort('expiration_date')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('expiration_date')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'expiration_date' }])
                            }, _toDisplayString(_ctx.getSortIcon('expiration_date')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': _ctx.isExpired(scope.row.expiration_date) })
                      }, _toDisplayString(_ctx.formatDate(scope.row.expiration_date)), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "quantity",
                    label: "在庫数",
                    width: "70",
                    "header-align": "center",
                    align: "right"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleSort('quantity')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('quantity')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'quantity' }])
                            }, _toDisplayString(_ctx.getSortIcon('quantity')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "払い出し方法",
                    width: "120",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.quantity > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (scope.row.payMode === 0)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "info"
                                }, {
                                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createTextVNode("新規")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (scope.row.payMode === 1)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                                    _createTextVNode("選択")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (scope.row.payMode === 2)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 2,
                                  type: "success"
                                }, {
                                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                                    _createTextVNode("追加")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (scope.row.payMode === 1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: "material-symbols-outlined cursor-pointer",
                                  onClick: ($event: any) => (_ctx.handlePayModeButton(scope.row))
                                }, " stat_minus_1 ", 8, _hoisted_25))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "払出数量",
                    width: "150",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.quantity > 0)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: "no-margin"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: scope.row.payQuantity,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.payQuantity) = $event),
                                min: 0,
                                max: scope.row.quantity,
                                "value-on-clear": 0,
                                onFocus: ($event: any) => (_ctx.handlePayQuantityChange(scope.row)),
                                onChange: ($event: any) => (_ctx.handlePayQuantityChange(scope.row))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onFocus", "onChange"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "メモ",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.quantity > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                onClick: ($event: any) => (_ctx.openMemoDialog(scope.row))
                              }, {
                                default: _withCtx(() => _cache[68] || (_cache[68] = [
                                  _createTextVNode(" 編集 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loading]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      style: {"max-width":"800px"},
      title: !_ctx.processing ? '払い出し確認' : '払い出し完了',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        (!_ctx.processing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createVNode(_component_el_button, {
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialogFormVisible = false))
              }, {
                default: _withCtx(() => _cache[73] || (_cache[73] = [
                  _createTextVNode("キャンセル")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleSubmit(_ctx.payFormRef)))
              }, {
                default: _withCtx(() => _cache[74] || (_cache[74] = [
                  _createTextVNode(" 確認 ")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.processing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dialogFormVisible = false))
              }, {
                default: _withCtx(() => _cache[75] || (_cache[75] = [
                  _createTextVNode(" 閉じる ")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.payForm,
          rules: _ctx.payRules,
          ref: "payFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_el_form_item, {
                  label: "部門（元）",
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DepartmentSelect, {
                      "organization-id": _ctx.payForm.organization_id,
                      modelValue: _ctx.payForm.target_department_id,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.payForm.target_department_id) = $event)),
                      disabled: true
                    }, null, 8, ["organization-id", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_form_item, {
                  label: "部門（先）",
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DepartmentSelect, {
                      "organization-id": _ctx.payForm.organization_id,
                      modelValue: _ctx.payForm.dest_department_id,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.payForm.dest_department_id) = $event)),
                      disabled: true
                    }, null, 8, ["organization-id", "modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_el_form_item, {
                  label: "操作者",
                  prop: "transfer_operator",
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      maxlength: "10",
                      modelValue: _ctx.payForm.transfer_operator,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.payForm.transfer_operator) = $event)),
                      placeholder: "操作者を入力",
                      autocomplete: "off",
                      disabled: _ctx.processing
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _cache[69] || (_cache[69] = _createElementVNode("div", { class: "flex-1" }, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.payForm.details,
          style: {"width":"100%"},
          "highlight-current-row": "",
          "header-row-class-name": "table-header-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "material_name",
              label: "アイテム名",
              width: _ctx.processing ? 246 : 298
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "storage_date",
              label: "保管日",
              "header-align": "center",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.storage_date)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "expiration_date",
              label: "有効期限",
              "header-align": "center",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'text-red-500': _ctx.isExpired(scope.row.expiration_date) })
                }, _toDisplayString(_ctx.formatDate(scope.row.expiration_date)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "quantity",
              label: "在庫数",
              width: "70",
              "header-align": "center",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "払い出し方法",
              width: "120",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.payMode === 0)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "info"
                    }, {
                      default: _withCtx(() => _cache[70] || (_cache[70] = [
                        _createTextVNode("新規")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.payMode === 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "primary"
                    }, {
                      default: _withCtx(() => _cache[71] || (_cache[71] = [
                        _createTextVNode("選択")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.payMode === 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[72] || (_cache[72] = [
                        _createTextVNode("追加")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "payQuantity",
              label: "払出数量",
              width: "80",
              align: "right"
            }),
            (_ctx.processing)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "",
                  label: "状態",
                  width: "52",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.process_status === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_el_icon, { color: "#67C23A" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SuccessFilled)
                            ]),
                            _: 1
                          })
                        ]))
                      : (scope.row.process_status === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createVNode(_component_el_icon, { color: "#F56C6C" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CircleCloseFilled)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(_component_el_icon, { color: "#909399" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Loading)
                              ]),
                              _: 1
                            })
                          ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading2]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.selectedTargetInventorydialogFormVisible,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.selectedTargetInventorydialogFormVisible) = $event)),
      style: {"max-width":"800px"},
      title: "払い出し",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_ctx.selectedTargetInventoryError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.selectedTargetInventoryError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_el_button, {
                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.selectedTargetInventorydialogFormVisible = false))
              }, {
                default: _withCtx(() => _cache[77] || (_cache[77] = [
                  _createTextVNode("キャンセル")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleSelectedTargetInventorySubmit
              }, {
                default: _withCtx(() => _cache[78] || (_cache[78] = [
                  _createTextVNode(" 払い出し ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.transferInventoryForm.material_name) + " （保管日：" + _toDisplayString(_ctx.formatDate(_ctx.transferInventoryForm.storage_date ?? '')) + "，有効期限：" + _toDisplayString(_ctx.formatDate(_ctx.transferInventoryForm.expiration_date ?? '')) + "）", 1)
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.sortedPaginatedTargetInventory,
            style: {"width":"100%"},
            "highlight-current-row": "",
            "header-row-class-name": "table-header-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "",
                width: "50",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_el_radio, {
                      "model-value": _ctx.selectedTargetInventory.inventory_id,
                      label: row.inventory_id,
                      "onUpdate:modelValue": ($event: any) => (_ctx.handleTargetInventorySelect(row)),
                      class: "radio-center"
                    }, {
                      default: _withCtx(() => _cache[76] || (_cache[76] = [
                        _createElementVNode("span", null, null, -1)
                      ])),
                      _: 2
                    }, 1032, ["model-value", "label", "onUpdate:modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "storage_date",
                width: "120",
                align: "left"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.handleTargetInventorySort('storage_date')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('storage_date')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'storage_date' }])
                        }, _toDisplayString(_ctx.getTargetInventorySortIcon('storage_date')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(row.storage_date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "expiration_date",
                width: "120",
                align: "left"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleTargetInventorySort('expiration_date')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('expiration_date')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'expiration_date' }])
                        }, _toDisplayString(_ctx.getTargetInventorySortIcon('expiration_date')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(row.expiration_date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "quantity",
                width: "100",
                align: "left"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleTargetInventorySort('quantity')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('quantity')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'quantity' }])
                        }, _toDisplayString(_ctx.getTargetInventorySortIcon('quantity')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "location",
                "min-width": "120"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.handleTargetInventorySort('location')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('location')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'location' }])
                        }, _toDisplayString(_ctx.getTargetInventorySortIcon('location')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "comment",
                "min-width": "120"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.handleTargetInventorySort('comment')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('comment')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'comment' }])
                        }, _toDisplayString(_ctx.getTargetInventorySortIcon('comment')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.targetInventoryListLoading]
          ]),
          (_ctx.targetInventoryTotal > _ctx.targetInventoryPageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.targetInventoryCurrentPage,
                  "onUpdate:currentPage": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.targetInventoryCurrentPage) = $event)),
                  "page-size": _ctx.targetInventoryPageSize,
                  total: _ctx.targetInventoryTotal,
                  layout: "prev, pager, next",
                  onCurrentChange: _ctx.handleTargetInventoryPageChange
                }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.memoDialogVisible,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.memoDialogVisible) = $event)),
      style: {"max-width":"800px"},
      title: "メモ編集",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_el_button, {
            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.memoDialogVisible = false))
          }, {
            default: _withCtx(() => _cache[79] || (_cache[79] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleMemoSubmit
          }, {
            default: _withCtx(() => _cache[80] || (_cache[80] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          modelValue: _ctx.memo,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.memo) = $event)),
          autosize: { minRows: 3, maxRows: 8 }
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.zeroQuantityDialogVisible,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.zeroQuantityDialogVisible) = $event)),
      style: {"max-width":"800px"},
      title: "在庫数 0 のレコード削除",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_el_button, {
            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.zeroQuantityDialogVisible = false))
          }, {
            default: _withCtx(() => _cache[81] || (_cache[81] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.handleDeleteZeroQuantity
          }, {
            default: _withCtx(() => _cache[82] || (_cache[82] = [
              _createTextVNode(" 削除 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          ref: "zeroQuantityTableRef",
          data: _ctx.zeroQuantityList,
          style: {"width":"100%"},
          onSelectionChange: _ctx.handleZeroQuantitySelection
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "material_name",
              label: "アイテム名",
              "min-width": "380"
            }),
            _createVNode(_component_el_table_column, {
              prop: "storage_date",
              label: "保管日",
              width: "100",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.storage_date)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "expiration_date",
              label: "有効期限",
              width: "100",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'text-red-500': _ctx.isExpired(scope.row.expiration_date) })
                }, _toDisplayString(_ctx.formatDate(scope.row.expiration_date)), 3)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}